<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 240px">
        <p>所属供应商：</p>
        <el-input v-model="supplierIpt" size="mini" style="width:150px" placeholder="请输入所属供应商"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>港口名称：</p>
        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入港口名称"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>状态：</p>
        <el-select v-model="stateIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.value" :label="item.name" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}">
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="supplierName" label="所属供应商" min-width="150" align="center"/>
          <el-table-column prop="portName" label="港口名称" width="150" align="center"/>
          <el-table-column prop="area" label="所在区域" align="center" width="150"/>
          <el-table-column prop="address" label="详细地址" align="center" width="150"/>
          <el-table-column prop="status" label="状态" align="center" width="60">
            <div slot-scope="scope">{{scope.row.status==0?'禁用中':'启用中'}}</div>
          </el-table-column>
          <el-table-column label="操作" width="290" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>
                <el-button size="mini" type="primary" @click="vehicleLane(scope.row)">车道</el-button>
                <!-- <el-button size="mini" type="primary" @click="bindClick(scope.row)">绑定</el-button> -->
                <el-button size="mini" type="info" @click="deleteClick(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"/>
      </div>
    </div>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='700px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">港口名称：</span>
              <span>{{detailData.portName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">所在区域：</span>
              <span>{{detailData.area}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">详细地址：</span>
              <span>{{detailData.address}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">所属供应商：</span>
              <span>{{detailData.supplierName}}</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.operateRecordList" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 新增/修改 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='650px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="company">
        <el-form :model="companyData" label-width="95px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息">
            <el-row>
              <el-col>
                <el-form-item label="港口名称：" prop="portName" style="margin-top: 10px;">
                  <el-input v-model="companyData.portName" placeholder="请输入港口名称" size="mini" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="所在区域：" prop="area">
                  <el-cascader v-model="companyData.area" :options="regionList" style="width:100%"
                  :props="{
                    expandTrigger: 'hover',
                    value: 'id',
                    label: 'cityName',
                    children: 'children',
                    multiple: false,
                  }"
                  size="mini" collapse-tags clearable placeholder="请选择所在区域" ref="areaCas" filterable @change="areaChange"/>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="详细地址：" prop="address">
                  <el-input v-model="companyData.address" placeholder="请输入详细地址" size="small" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="所属供应商：" prop="supplier">
                  <el-select filterable v-model="companyData.supplier" size="small" style="width:100%" placeholder="请选择" value-key="id">
                    <el-option v-for="item in supplierOption" :key="item.id" :label="item.supplier_name" :value="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div class="btnContainer">
            <el-button class="searchBtn" size="small" :loading="addLoad" @click="addClick">确认</el-button>
            <el-button class="resetBtn" size="small" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 绑定供应商 -->
    <el-dialog title="绑定供应商" :visible.sync="bindVisible" width="650px" center>
      <div class="bind-form" v-if="bindData.supplierType==0">
        <el-form :model="bindData" label-width="150px" :rules="bindRules" ref="bindForm">
          <el-form-item label="供应商：" prop="supplier" style="margin-top: 10px;">
            <el-select filterable v-model="bindData.supplier" size="small" style="width:350px" placeholder="请选择" value-key="id">
              <el-option v-for="item in supplierOption" :key="item.id" :label="item.supplier_name" :value="item"/>
            </el-select>
          </el-form-item>
          <div class="btnContainer">
            <el-button class="searchBtn" size="small" :loading="addLoad" @click="bindConfirm">确认</el-button>
            <el-button class="resetBtn" size="small" @click="bindClose">关闭</el-button>
          </div>
        </el-form>
      </div>
      <div class="detail" v-else>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <span style="display:inline-block;width:80%;text-align:right;">
              <el-button size="mini" type="primary" :loading="addLoad" @click="unbindClick" class="resetBtn">解绑供应商</el-button>
            </span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">供应商全称：</span>
              <span>{{bindData.supplierName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">供应商简称：</span>
              <span>{{bindData.supplierNameShort}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">类型：</span>
              <span>{{bindData.type==1?'港口':'其他'}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">邮箱：</span>
                <span>{{bindData.mailbox}}</span>
              </div>
              <div>
                <span class="span1">电话：</span>
                <span>{{bindData.telephone}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">详情地址：</span>
              <span>{{bindData.address}}</span>
            </div>
            <div v-for="item in bindData.person" :key="item.id">
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">对接人姓名：</span>
                  <span>{{item.name}}</span>
                </div>
                <div>
                  <span class="span1">对接人电话：</span>
                  <span>{{item.tell}}</span>
                </div>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">对接人职位：</span>
                <span>{{item.position}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 车道 -->
    <el-dialog title="车道管理" :visible.sync="cabinVisible" width="650px" center>
      <div class="cabin">
        <div style="margin: 0 0 10px 0">
          <el-button size="mini" class="searchBtn" @click="cabinAdd">添加</el-button>
        </div>
        <el-table
          v-loading="cabinLoad"
          :data="cabinTable"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{'color':'#7F7F7F','font-size':'13px','height':'48px',}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column type="index" label="序号" width="50" align="center"/>
          <el-table-column prop="garageName" label="车道名" align="center"/>
          <!-- <el-table-column prop="status" label="状态" align="center"/> -->
          <el-table-column prop="garageNum" label="可停车数量" align="center" width="100"/>
          <el-table-column prop="garageFreeNum" label="已停放数量" align="center"/>
          <el-table-column  label="操作" align="center" width="210px">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" class="yellow-bg" @click="cabinUpdateClick(scope.row)">修改</el-button>
              <!-- <el-button size="mini" :type="scope.row.status !=='启用' ? 'primary':'danger'" @click="cabinEnableClick(scope.row)">{{scope.row.status !=='启用'?'启用':'禁用'}}</el-button> -->
              <el-button size="mini" type="primary" @click="deleLines(scope.row.id)" class="resetBtn">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px;"
          @size-change="contractSizeChanges"
          @current-change="contractCurrentChanges"
          :current-page.sync="cabinFrom.page"
          :page-size="cabinFrom.rows"
          :page-sizes="[10, 20, 30, 40]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="cabinTotal">
        </el-pagination>
        <el-dialog :title="`${cabinDialogName}车道`" :visible.sync="cabinAddVisible" append-to-body center width="500px" @close="cabinDialogClose">
          <div style="padding: 20px">
            <el-form :model="cabinData" label-width="110px" :rules="cabinRules" ref="cabinRuleForm" size="medium">
              <el-form-item label="车道名:" prop="cabinName">
                <el-input size="mini" v-model="cabinData.cabinName" style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item label="可停车数量:" prop="boatNumber">
                <el-input size="mini" v-model="cabinData.boatNumber" style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item label-width="0px" style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: center;">
                <el-button class="searchBtn" size="mini"  @click="cabinAddClick">确认</el-button>
                <el-button class="resetBtn" size="mini" @click="cabinDialogClose">关闭</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {formatDateTime, getSessionStore, removeSpace} from "@/config/mUtils";
  import divBorder from "@/components/divBorder";
  import { portManagePageList,portDetail,portAdd,portUpdate,portDelete,supplierBind,supplierList,
  supplierPortOtherDetail,laneAdd,laneUpdate,laneDelete,laneIsEnable,lanePageList, } from "@/service/basicfile"

  export default {
    components: { divBorder },
    data() {
      return {
        // 查询条件
        nameIpt: '',
        supplierIpt: '',
        stateIpt: '',
        page: 1,
        size: 10,
        total: 0,
        // 状态
        stateOption:[{value:'',name:'全部'},{value:1,name:'启用中'},{value:0,name:'禁用中'}],

        // 分页表格数据
        tableLoad:false,
        TableDatas:[],

        // 绑定供应商 -- 数据
        bindVisible: false,
        supplierOption: [],
        bindData: {},
        bindRules: { supplier:{ required: true, message: '请选择供应商', trigger: 'blur' } },

        // 详情 -- 数据
        detailDialogVisible:false,    // 弹窗控制
        detailData:{},

        // 新增/修改 -- 数据
        dialogVisible:false,    // 弹窗控制
        regionList: [],   // 区域
        dialogTitle:'',   // 标题
        addLoad:false,
        companyData:{},
        rules:{
          portName: { required: true, message: '请输入港口名称', trigger: 'blur' },
          area: { required: true, message: '请选择所在区域', trigger: 'change' },
          address: { required: true, message: '请输入详细地址', trigger: 'blur' },
          supplier: { required: true, message: '请选择所属供应商', trigger: 'blur' },
        },

        // 车道 -- 数据
        cabinVisible: false,    // 车道弹窗控制
        cabinAddVisible:false,    // 车道 -- 新增/修改弹窗控制
        portIds: '',    // 港口id
        cabinFrom: {    // 查询条件
          rows:10,
          page:1,
        },
        cabinTotal: 0,
        cabinLoad: false,   // 加载状态
        cabinTable: [],   // 车道表格数据
        cabinDialogName:'添加',   // 车道 -- 新增/修改弹窗标题
        cabinData: {    // 新增/修改数据
          shipId:'',
          cabinName:'',
          boatNumber:'',
          freeNumber:'',
        },
        cabinRules:{
          cabinName:{ required: true, message: '请输入车道名', trigger: 'blur' },
          boatNumber:{ required: true, message: '请输入可停车数量', trigger: 'blur' },
          freeNumber:{ required: true, message: '请输入空闲数量', trigger: 'blur' },
        },
      };
    },
    computed:{
      getTime(){
        return function(time){
          return formatDateTime(time,'yyyy-mm-dd hh:ii:ss');
        };
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      async init(){
        await this._portManagePageList();
        this.regionList = JSON.parse(getSessionStore("areaList"));
      },
      // 分页查询
      async _portManagePageList(){
        this.tableLoad = true;
        let obj = {
          portName: this.nameIpt,
          supplierName: this.supplierIpt,
          status: this.stateIpt,
          page:this.page,
          rows:this.size,
        }
        const res = await portManagePageList(obj);
        this.tableLoad = false;
        if(res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 改变每页数据量
      contractSizeChange(sizes){
        this.size = sizes;
        this._portManagePageList();
      },
      // 翻页
      contractCurrentChange(page){
        this.page = page;
        this._portManagePageList();
      },
      // 详情
      async detailClick(id){
        const res = await portDetail(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        this.detailDialogVisible = true;
      },
      // 修改
      async changeClick(item){
        // 获取供应商
        const res = await supplierList();
        if(res.status !== 0) return this.$message.error(res.message);
        this.supplierOption = res.data;

        let arr4 = [];
        if(item.areaFullId.search('/')!=-1){
          arr4 = item.areaFullId.split('/')||[];
        }else{
          arr4 = item.areaFullId.split(',')||[];
        }
        this.companyData={
          ...item,
          areaName: item.area,
          area:arr4,
          center:item.coordinate,
          supplier:{supplier_name:item.supplierName,id: item.supplierId},
        };
        this.dialogTitle = '修改港口';
        this.dialogVisible = true;
      },
      // 删除
      deleteClick(row){
        this.$confirm('确定要删除当前港口吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await portDelete(row.id);
          if(res.status !== 0) return this.$message.error(res.message);
          else this.$message.success(res.message);
          this._portManagePageList();
        }).catch(() => {});
      },
      // 查询
      searchBtn(){
        this.page = 1;
        this._portManagePageList();
      },
      // 重置
      resetBtn(){
        this.nameIpt='';
        this.supplierIpt='';
        this.stateIpt='';
      },
      // 新增 -- 打开弹窗
      async addBtn(){
        this.dialogTitle = '新增港口';
        this.companyData = {};
        // 获取供应商
        const res = await supplierList();
        if(res.status !== 0) return this.$message.error(res.message);
        this.supplierOption = res.data;

        this.dialogVisible = true;
      },
      // 区域改变
      areaChange(){
        this.$nextTick(()=>{
          this.companyData.center = this.$refs.areaCas.getCheckedNodes()[0].data.center;
          this.companyData.areaName = this.$refs.areaCas.getCheckedNodes()[0].pathLabels.join('/');
        })
      },
      // 新增/修改 -- 确认
      addClick(){
        this.companyData=removeSpace(this.companyData);
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.addLoad = true;
            let obj = {
              id: this.companyData.id,
              portName: this.companyData.portName,
              areaId: this.companyData.area[this.companyData.area.length -1],
              areaFullId: this.companyData.area.join('/'),
              area: this.companyData.areaName,
              coordinate: this.companyData.center,
              address: this.companyData.address,
              supplierName: this.companyData.supplier.supplier_name,
              supplierId: this.companyData.supplier.id,
            };
            const res = this.dialogTitle=='新增港口'?await portAdd(obj):await portUpdate(obj);
            this.addLoad = false;
            if(res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible = false;
            await this._portManagePageList();
          } else return false;
        });
      },
      // 新增/修改 -- 关闭弹窗
      dialogClose(){
        this.dialogVisible=false;
        this.$refs.ruleForm.resetFields();
      },

      /**
       * 绑定供应商
       */
      // 绑定供应商 -- 打开弹窗
      async bindClick(row){
        this.bindData = {id: row.id, supplierType: row.supplierType, supplier: ''};
        if(row.supplierType == 0) {   // 未绑定供应商
          const res = await supplierList(row.id);
          if(res.status !== 0) return this.$message.error(res.message);
          this.supplierOption = res.data;
        }else {   // 已绑定供应商
          const res = await supplierPortOtherDetail(row.supplierId);
          if(res.status !== 0) return this.$message.error(res.message);
          const nameArr = res.data.directorName?res.data.directorName.split(','):[];
          const tellArr = res.data.directorMobile?res.data.directorMobile.split(','):[];
          const positionArr = res.data.directorPost?res.data.directorPost.split(','):[];
          const arr = nameArr.map((item,index)=>{
            return { id: index, name:item, tell:tellArr[index], position:positionArr[index] }
          })
          this.bindData = { ...res.data, person:arr };
        }
        this.bindVisible = true;
      },
      // 绑定供应商 -- 确认
      bindConfirm(){
        this.$refs.bindForm.validate(async (valid) => {
          if (valid) {
            let obj = {
              id: this.bindData.id,
              supplierType: 1,
              supplierId: this.bindData.supplier.id,
              supplierName: this.bindData.supplier.supplierName,
            };
            this.addLoad = true;
            let res = await supplierBind(obj);
            this.addLoad = false;
            if(res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.bindVisible = false;
            this._portManagePageList();
            this.bindClose();
          } else return false;
        });
      },
      // 绑定供应商 -- 取消
      bindClose() {
        this.bindData = {};
        this.$refs.bindForm.resetFields();
        this.bindVisible = false;
      },
      // 解绑供应商
      unbindClick(){
        this.$confirm('确定要给当前港口解绑供应商吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.addLoad = true;
          let obj = {
            id: this.bindData.portId,
            supplierType: 0,
            supplierId: this.bindData.id,
            supplierName: this.bindData.supplierName,
          };
          const res = await supplierBind(obj);
          this.addLoad = false;
          if(res.status !== 0) return this.$message.error(res.message);
          else this.$message.success(res.message);
          this.bindVisible = false;
          this._portManagePageList();
          this.bindClose();
        }).catch(() => {});
      },

      /**
       * 车道
       */
      // 车道管理 -- 打开弹窗
      vehicleLane(item){
        this.cabinVisible = true;
        this.portIds = item.id
        this.lineSearch();
      },
      // 车道 -- 分页查询
      lineSearch(){
        const data = {
          portId:this.portIds,
          page:this.cabinFrom.page,
          rows:this.cabinFrom.rows,
        }
        this.vLanes(data)
      },
      async vLanes(data){
        const res =await lanePageList(data);
        if (res.status == 0){
          this.cabinTable=[];
          res.data.records.forEach((item)=>{
            if (item.status===1){
              item.status='启用'
            }else {
              item.status='禁用'
            }
            this.cabinTable.push(item);
          })
          this.cabinTotal = res.data.total;
        }else this.$message.warning(res.message)
      },
      contractSizeChanges(sizes){
        this.cabinFrom.rows = sizes;
        this.lineSearch();
      },
      contractCurrentChanges(page){
        this.cabinFrom.page = page;
        this.lineSearch();
      },
      // 车道 -- 删除
      async deleLines(ids){
        const res = await laneDelete(ids);
        if(res.status == 0){
          this.lineSearch();
          this.$message.success(res.message);
        }else this.$message.warning(res.message);
      },
      // 车道 -- 启用/禁用按钮 打开弹窗(1启用，0禁用)
      cabinEnableClick(ret){
        if (ret.status == '启用'){ ret.status='0'; }
        else { ret.status='1'; }
        let data = {
          id:ret.id,
          statusNum:ret.status
        }
        this.laneIsEnable(data);
      },
      // 车道 -- 调用启用/禁用接口
      async laneIsEnable(data){
        const res = await laneIsEnable(data);
        if(res.status===0){
          this.$message.success(res.message)
        }else this.$message.warning(res.message)
        await this.lineSearch();
      },
      // 车道 -- 添加按钮 打开弹窗
      cabinAdd(){
        this.cabinAddVisible = true
        this.cabinDialogName = '添加'
      },
      // 车道 -- 调用添加接口
      async _laneAdd(data){
        const res = await laneAdd(data);
        if(res.status===0) this.$message.success(res.message);
        else this.$message.error(res.message)
        this.lineSearch();
        this.cabinDialogClose();
      },
      // 车道 -- 新增/修改  确认
      cabinAddClick(){
        this.$refs.cabinRuleForm.validate(async (valid) => {
          if (valid){
            if(this.cabinDialogName == '修改'){
              const data={
                id: this.cabinData.id,
                portId: this.portIds,
                garageName: this.cabinData.cabinName,
                garageNum: this.cabinData.boatNumber,
              }
              this._laneUpdate(data);
            }else {
              const data={
                portId: this.portIds,
                garageName: this.cabinData.cabinName,
                garageNum: this.cabinData.boatNumber,
              }
              this._laneAdd(data);
            }
          }else {
          }
        })
      },
      // 车道 -- 修改按钮 打开弹窗
      cabinUpdateClick(item){
        this.cabinAddVisible = true;
        this.cabinDialogName = '修改';
        this.cabinData = {
          id:item.id,
          cabinName:item.garageName,
          boatNumber:item.garageNum,
        }
      },
      // 车道 -- 调用修改接口
      async _laneUpdate(data){
        const res = await laneUpdate(data);
        if (res.status===0){
          this.$message.success(res.message)
          this.lineSearch();
          this.cabinDialogClose();
        }else this.$message.error(res.message)
      },
      // 车道 -- 新增/修改 关闭弹窗
      cabinDialogClose(){
        this.$refs.cabinRuleForm.resetFields();
        this.cabinData = {
          shipId:'',
          cabinName:'',
          boatNumber:'',
          freeNumber:'',
        }
        this.cabinAddVisible = false;
      },
    },
  };
</script>



<style lang="scss" scoped>
  .mainContainer{
    width:100%;
    padding:20px 15px 0 25px;
    background-color: #fff;
    .line{
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }
    .line +span{
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }
    .nav{
      width:100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &Container{
        width:200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;
        p{
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }
      &Btn{
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    .content{
      display: flex;
      flex-direction: column;
      align-items: center;
      .tableContainer{
        margin-top: 15px;
        margin-bottom: 25px;
        width: 100%;
        ::v-deep{
          .el-table .cell {
            padding: 0;
          }
          .el-table th{
            padding: 0;
          }
          .el-table td{
            padding: 0;
          }
        }
      }
      .paginationContainer{
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        span{
          font-size: 13px;
        }
      }
    }
    .detail{
      width: 100%;
      padding: 10px 0 20px 20px;
      .baseInfo{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          &Item{
            margin-bottom: 20px;
            .span1{
              font-weight: 700;
            }
            span{
              font-size: 14px;
            }
            .specialOne{
              width:50%;
            }
          }
          .specialItem{
            display:flex;
          }
        }
      }
      .operation{
        display: flex;
        flex-direction: column;
        ::v-deep{
          .el-table td, .el-table th{
            padding:0;
          }
          .cell{
            font-size: 10px;
            padding:0;
          }
        }
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table{
          width:100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }
    .company{
      width:100%;
      padding: 40px 30px 10px 30px;
      .unitContainer{
        display: flex;
        align-items:center;
        margin-bottom:5px;
        ::v-deep{
          .el-input__inner{
            border: 1px solid #DCDFE6;
          }
        }
      }
      .unitContainer2{
        display: flex;
        align-items:center;
        //justify-content:space-between;
        //width:189px;
        margin-bottom:5px;
        span{
          color: #606266;
          font-weight: 700;
        }
        ::v-deep{
          .el-input__inner{
            border: 1px solid #DCDFE6;
          }
        }
      }
      ::v-deep{
        .el-form-item__label{
          font-weight: 700;
        }
        .el-form-item__label{
          padding:0;
        }
        .el-form-item__content{
          position: relative;
        }
        .el-form-item{
          margin-bottom:13px;
        }
      }
      .btnContainer{
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        button{
          margin: 0 15px;
        }
      }
    }
    .bind-form {
      width:100%;
      padding: 20px 30px 10px 30px;
      .btnContainer{
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        button{
          margin: 0 15px;
        }
      }
    }
    ::v-deep{
      .el-table th>.cell{
        font-weight: 700!important;
      }
    }
    .cabin{
      padding: 25px;
      width: 100%;
    }
  }
  ::v-deep{
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .el-dialog__headerbtn{
      top:9px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
</style>
